/**
 * Small UPS list column width tokens — equal flex per rack table design (#1154).
 */

import {
  repeatableColumnCellStyle,
  repeatableColumnHorizontalPadding,
  repeatableCompactColumnLayoutForTests,
  repeatableDesktopColumnLayoutForTests,
} from '../repeatableSections/repeatableTableColumnLayout';

import type {
  SmallUpsTableColumnKey,
  SmallUpsTableLayout,
} from './smallUpsListUtils';

export function smallUpsColumnHorizontalPadding(
  column: SmallUpsTableColumnKey,
  layoutMode: SmallUpsTableLayout,
): number {
  return repeatableColumnHorizontalPadding(column, layoutMode);
}

export function smallUpsColumnCellStyle(
  column: SmallUpsTableColumnKey,
  layoutMode: SmallUpsTableLayout,
): Record<string, unknown> {
  const paddingHorizontal = smallUpsColumnHorizontalPadding(column, layoutMode);
  // Desktop: keep STATUS compact. Compact/mobile: equal flex with other columns.
  if (column === 'STATUS' && layoutMode !== 'compact') {
    return {
      flex: 0,
      flexGrow: 0,
      flexShrink: 0,
      width: 84,
      minWidth: 84,
      paddingHorizontal,
    };
  }
  return repeatableColumnCellStyle(column, layoutMode);
}

/** @internal — unit tests assert equal flex layout. */
export const desktopColumnLayoutForTests =
  repeatableDesktopColumnLayoutForTests;

/** @internal — unit tests assert equal flex layout. */
export const compactColumnLayoutForTests =
  repeatableCompactColumnLayoutForTests;
